import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=f544a686&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"
import style0 from "./Admin.vue?vue&type=style&index=0&id=f544a686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f544a686",
  null
  
)

export default component.exports